import { ADD_PROFILE_DETAILS, ADD_PROFILE_IMAGE,FCM_TOKEN } from './action';

const initialState = {
  profile_setting: null,
  FCM_Token: null
};

export const profileReducer = (state = initialState, action: any) => {

  switch (action.type) {
    case ADD_PROFILE_DETAILS:
      return {
        ...state,
        profile_setting: action.payload,
      };
    case ADD_PROFILE_IMAGE:
      return {
        ...state,
        profile_setting: action.payload.file,
      };
    case FCM_TOKEN: {
      return {
        ...state,
        FCM_Token: action.payload
      }
    }
    default:
      return state;
  }
};
